import { createAction } from 'redux-actions'

const ICE_CONNECTION_STATE = 'ICE_CONNECTION_STATE'
const CLOSE_PEER_CONNECTION = 'CLOSE_PEER_CONNECTION'
export const ACCESS_GRANTED = 'ACCESS_GRANTED'
export const ACCESS_REJECTED = 'ACCESS_REJECTED'
export const ACCESS_PENDING = 'ACCESS_PENDING'
export const CONNECTION_CLOSED_BY_PEER = 'CONNECTION_CLOSED_BY_PEER'
const ACCESS_CONFIRMATION_CANCELLED = 'ACCESS_CONFIRMATION_CANCELLED'
const RESET_VIDEO_STREAM = 'RESET_VIDEO_STREAM'
const RESET_AUDIO_STREAM = 'RESET_AUDIO_STREAM'
const CHANGE_MONITOR = 'CHANGE_MONITOR'
export const CONNECTION_UNSTABLE = 'CONNECTION_UNSTABLE'
const AUDIO_CHAT_TRACK_CHANGE = 'AUDIO_CHAT_TRACK_CHANGE'
const SEND_COMMAND = 'SEND_COMMAND'

export const iceConnectionState = createAction(ICE_CONNECTION_STATE)
export const closePeerConnection = createAction(CLOSE_PEER_CONNECTION)
export const accessPending = createAction(ACCESS_PENDING)
export const accessGranted = createAction(ACCESS_GRANTED)
export const accessRejected = createAction(ACCESS_REJECTED)
export const accessConfirmationCancelled = createAction(ACCESS_CONFIRMATION_CANCELLED)
export const connectionClosedByPeer = createAction(CONNECTION_CLOSED_BY_PEER)
export const resetVideoStream = createAction(RESET_VIDEO_STREAM)
export const resetAudioStream = createAction(RESET_AUDIO_STREAM)
export const changeMonitor = createAction(CHANGE_MONITOR)
export const connectionUnstable = createAction(CONNECTION_UNSTABLE)
export const audioChatTrackChange = createAction(AUDIO_CHAT_TRACK_CHANGE)
export const sendCommand = createAction(SEND_COMMAND)
